var exports = {
  "WB": "FavoritesWelcomeSection.module__welcomeSection___VUlVQl",
  "r2": "FavoritesWelcomeSection.module__iconSection___VUlVQl",
  "P0": "FavoritesWelcomeSection.module__iconWrapper___VUlVQl",
  "Kk": "FavoritesWelcomeSection.module__icon___VUlVQl",
  "Jo": "FavoritesWelcomeSection.module__contentSection___VUlVQl",
  "R_": "FavoritesWelcomeSection.module__heading___VUlVQl",
  "h_": "FavoritesWelcomeSection.module__description___VUlVQl",
  "uN": "FavoritesWelcomeSection.module__tip___VUlVQl",
  "A2": "FavoritesWelcomeSection.module__actionSection___VUlVQl",
};

module.exports = exports;
